import React, {useEffect, useState} from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useTranslation} from "react-i18next";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {PrimaryBigButton} from "../../components/buttons/mainButton";
import {TOperation} from "../../interfaces/operation";
import {TEmailTemplate} from "../../interfaces/email";
import {updateEmailTemplatePeriodicity} from "../../services/AdminService";

type periodicityEmailProps = {
  openDialog: boolean,
  closeDialog: () => void,
  operation?: TOperation,
  templateMail? : TEmailTemplate
}

export default function PeriodicityEmail(props: periodicityEmailProps): JSX.Element {
  const {openDialog, closeDialog, operation, templateMail} = props;
  const {t} = useTranslation();

  const [periodicity, setPeriodicity] = useState<number>();

  const onConfirmPeriodicity = (): void => {
    if (!templateMail || periodicity == null) return;

    updateEmailTemplatePeriodicity(templateMail.id, periodicity)
      .then(() => {
        closeDialog();
      })
      .catch(() => {
        console.error("Erreur lors de la mise à jour de la périodicité");
      });
  };

  useEffect(() => {
    if (openDialog && templateMail?.periodicity != null) {
      setPeriodicity(templateMail.periodicity);
    }
  }, [openDialog, templateMail]);

  return (operation == null && templateMail ==null) ? <></> :
    <Dialog open={openDialog} onClose={closeDialog} sx={{display: "flex", justifyContent: "center"}}>
      <DialogTitle>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb:5}}>
          <label>{t('email_templates.perodicity.title')}</label>
          <IconButton onClick={closeDialog}><CloseIcon/></IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TextField value={periodicity ?? ""} onChange={(event: any): void => !isNaN(event.target.value) ? setPeriodicity(Math.abs(event.target.value)): setPeriodicity(0)} type="string" color="info"
          sx={{width: '80%', mr: 2, "& input": {p: 3}}}
          InputProps={{
            lang: "fr-FR",
            endAdornment: <InputAdornment position="end"><Typography color="neutral.dark" sx={{fontWeight: "regular"}} variant="body2">{t('email_templates.perodicity.unit')}  </Typography></InputAdornment>,
            inputProps: {
              min: 1,
            }
          }}
        />
        <Box sx={{display: 'flex', alignItems: 'center', mt:2}}>
          <InfoOutlinedIcon sx={{color: 'info.main', height: "15px", mr: 0}}/>
          <Typography color="info.main" sx={{fontWeight: "regular"}} variant="body1">
            {t("email_templates.perodicity.content", {count: periodicity??0})}</Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{display: 'flex', justifyContent: 'right', borderTop: "1px solid", borderColor: "ornament.dark", p: 5}}>
        <PrimaryBigButton
          label={t('email_templates.perodicity.confirm')}
          action={onConfirmPeriodicity}
        />
      </DialogActions>
    </Dialog>
}
